import { Box, Flex } from "@chakra-ui/react";
import { Control } from "react-hook-form";
import InputToggleContent from "components/Input/InputToggleContent/index";
import Field from "components/Input/Field";
import { InputBaseWrapper } from "components/Features/Financeiro/FormConta/components/InputBaseWrapper";
import { ManutencaoForm } from "features/manutencao/typings/index";
import ButtonAnexarArquivos from "components/Button/ButtonAnexarArquivos";
import { UseFormSetValue } from "react-hook-form";
import { AiOutlinePlusCircle } from "react-icons/ai";
import Anexos from "components/Anexos";

interface FormAnexarArquivoProps {
  control: Control<ManutencaoForm, any>;
  form: ManutencaoForm;
  setValue: UseFormSetValue<ManutencaoForm>;
}

function FormAnexarArquivo({
  control,
  form,
  setValue,
}: FormAnexarArquivoProps) {
  return (
    <Box mb={2}>
      <Field
        shouldUnregister
        control={control}
        name="anexarArquivos"
        render={({ field: toggle }) => (
          <InputToggleContent
            label="Anexar arquivos"
            active={!!toggle.value}
            onToggle={toggle.onChange}
            size="sm"
            buttonIcon={
              <ButtonAnexarArquivos
                buttonIcon={<AiOutlinePlusCircle size={28} />}
                buttonText=""
                maxFileSizeMb={200}
                currentFilesLength={form.files?.length || 0}
                variant="ghost"
                onAnexar={(files) => {
                  if (files) {
                    const currentAnexos = form.files;

                    setValue(
                      "files",
                      currentAnexos ? [...currentAnexos, ...files] : files
                    );
                  }
                }}
              />
            }
          >
            <InputBaseWrapper gutter={16}>
              <Flex
                gap="16px"
                mt="auto"
                h="fit-content"
                px={4}
                py={2}
                flexDir="column"
              >
                {form.files?.length ? (
                  <Anexos
                    numColumns={2}
                    setValue={(anexos) => setValue("files", anexos as File[])}
                    anexos={form.files || undefined}
                  />
                ) : null}
              </Flex>
            </InputBaseWrapper>
          </InputToggleContent>
        )}
      />
    </Box>
  );
}

export default FormAnexarArquivo;
